import { ActionTypes } from ".";
export const cookieAction = ({ cookie }) => dispatch => {
  dispatch({
    type: ActionTypes.COOKIE,
    payload: cookie
  });
};
